import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import { Navigation } from 'swiper/modules';

export default function () {
    // Quotes slider
    const sliders = document.querySelectorAll('.quotes__slider');

    sliders.forEach((slider) => {
        new Swiper(slider, {
            modules: [Pagination, Autoplay],
            slidesPerView: 1,
            loop: true,

            autoplay: {
                delay: 5000,
            },

            pagination: {
                el: slider.querySelector('.quotes__pagination'),
                clickable: true,
            },
        });
    });

    // Services sliders
    const services = document.querySelectorAll('.services-carousel__slider');

    services.forEach((slider) => {
        const swiper = new Swiper(slider, {
            slidesPerView: 1,

            breakpoints: {
                1025: {
                    slidesPerView: 3,
                },
            },
        });

        const nextBtn = slider
            .closest('.services-carousel__category')
            ?.querySelector('.services-carousel__next');

        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                swiper.slideNext();
            });
        }
    });

     // showcase sliders
    const showcase = document.querySelectorAll('.project-detail-page__showcase__slider');

    showcase.forEach((slider) => {
        new Swiper(slider, {
            modules: [Navigation],
            slidesPerView: 1,
            loop: true,
            grabCursor: true,

            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
        });
    });
}